import { effectiveStatus, sortRecommendations } from './recommendations';

export const DECISION_BRIEF_VERSION = 'rules-brief-v1';

const QUESTIONS = {
  reorder: 'Ask what they need to replenish and when they would like the next order.',
  reactivate: 'Ask whether their buying needs have changed and what would make a follow-up useful.',
  follow_up: 'Ask which current buying needs they would like help with.',
  opp_next_step: 'Ask what is needed to agree on the next step and its timing.',
  contact_gap: 'Confirm who makes buying decisions and how they prefer to be contacted.',
  cross_sell: 'Ask whether previously purchased styles still fit their current needs.',
  seasonal: 'Ask whether they are planning an order for the upcoming buying period.'
};
const REVIEW_TABS = new Set(['contacts', 'tasks']);
const millis = value => typeof value?.toDate === 'function' ? value.toDate().getTime() : NaN;

export function buildDecisionBrief(customerId, insight, recommendations, now = new Date()) {
  const generatedAt = millis(insight?.generatedAt);
  if (!Number.isFinite(generatedAt) || generatedAt > now.getTime() ||
    typeof insight?.inputHash !== 'string' || !insight.inputHash) return null;
  const candidates = recommendations.filter(rec => {
    const generated = millis(rec.generatedAt);
    const expires = millis(rec.expiresAt);
    const action = rec.suggestedAction;
    return rec.customerId === customerId && rec.source === 'rules' &&
      Object.hasOwn(QUESTIONS, rec.type) && effectiveStatus(rec, now) === 'proposed' &&
      Number.isFinite(generated) && generated >= generatedAt && generated <= now.getTime() &&
      Number.isFinite(expires) && expires > now.getTime() &&
      typeof rec.id === 'string' && rec.id &&
      typeof rec.title === 'string' && rec.title.trim() &&
      typeof rec.rationale === 'string' && rec.rationale.trim() &&
      (action?.kind === 'create_task' ||
        (action?.kind === 'view_tab' && REVIEW_TABS.has(action.payload?.tab))) &&
      Array.isArray(rec.evidence) && rec.evidence.length > 0 &&
      rec.evidence.every(ref => ref && typeof ref.kind === 'string' && ref.kind &&
        typeof ref.refId === 'string' && ref.refId &&
        typeof ref.fact === 'string' && ref.fact);
  }).sort((a, b) => sortRecommendations(a, b) || a.id.localeCompare(b.id));
  const recommendation = candidates[0];
  if (!recommendation) return null;
  const coverage = insight.signals?.coverage;
  const missing = [];
  if (coverage?.contactCount === 0) missing.push('No contacts are recorded.');
  else if (coverage && !coverage.hasPrimary) missing.push('A primary buyer contact is not identified.');
  else if (coverage?.hasPrimary && !coverage.primaryHasEmail) missing.push('The primary contact has no recorded email.');
  return {
    version: DECISION_BRIEF_VERSION,
    recommendation,
    evidence: recommendation.evidence,
    question: QUESTIONS[recommendation.type],
    missing,
    uncertainty: 'Buying intent, budget and timing are not confirmed by these signals.',
    generatedAt: insight.generatedAt,
    inputHash: insight.inputHash
  };
}
